// only log to the console if not in production and not in unit tests
const processEnv = typeof process !== 'undefined' && process?.env?.NODE_ENV;
const shouldLog = processEnv !== 'test' && !window.mstPrd;
const devLogger = {
  log(...args) {
    if (shouldLog) {
      console.log(...args);
    }
  },
  info(...args) {
    if (shouldLog) {
      console.info(...args);
    }
  },
  error(...args) {
    if (shouldLog) {
      console.error(...args);
    }
  },
  warn(...args) {
    if (shouldLog) {
      console.warn(...args);
    }
  },
};
export default devLogger;
